export default function() {
    return {
        targets: [],
        changed: false
    }
}
